import { render, staticRenderFns } from "./AnalyteCard.vue?vue&type=template&id=a4cf1068"
import script from "./AnalyteCard.vue?vue&type=script&lang=js"
export * from "./AnalyteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports